import { render } from "./ourPartner.vue?vue&type=template&id=a98e584e&scoped=true"
import script from "./ourPartner.vue?vue&type=script&lang=js"
export * from "./ourPartner.vue?vue&type=script&lang=js"

import "./ourPartner.vue?vue&type=style&index=0&id=a98e584e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98e584e"]])

export default __exports__